/** Pages of the main M1NT website, mirrored from its own navigation menu. */
export const STORE_ORIGIN = 'https://m1ntaverse.com'

export const STORE_MENU = [
  { label: 'Home', href: `${STORE_ORIGIN}/` },
  { label: 'The M1NT Case G1', href: `${STORE_ORIGIN}/products/the-m1nt-case-g1` },
  {
    label: '“Grails Quest” Sport Hobby Case (35pt)',
    href: `${STORE_ORIGIN}/products/hobby-case-001`,
  },
  { label: 'TCG Hobby Case (35pt)', href: `${STORE_ORIGIN}/products/tcg-hobby-case-35pt` },
  { label: 'M1NT Apparel', href: `${STORE_ORIGIN}/products/m1nt-signature-series-hat` },
  { label: 'Store', href: `${STORE_ORIGIN}/collections/all` },
  {
    label: 'Wholesale Partner Application',
    href: `${STORE_ORIGIN}/pages/m1nt-wholesale-partner-application`,
  },
  { label: 'Contact', href: `${STORE_ORIGIN}/pages/contact` },
  { label: 'FAQ', href: `${STORE_ORIGIN}/pages/faq` },
]

export const STORE_SOCIALS = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=100088890717257',
    icon: 'ri-facebook-fill',
  },
  { label: 'Twitter / X', href: 'https://twitter.com/m1ntaverse', icon: 'ri-twitter-x-line' },
  { label: 'Instagram', href: 'https://www.instagram.com/m1ntaverse/', icon: 'ri-instagram-line' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@m1ntaverse', icon: 'ri-tiktok-line' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/m1nt', icon: 'ri-linkedin-fill' },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/channel/UCYFUvGneEeiceECylH-hQgw',
    icon: 'ri-youtube-line',
  },
]
